require("core-js/modules/es6.regexp.replace");
// 开发环境接口配置
// JAVA Boot版本对应后端接口地址
// JAVA Cloud对应网关地址

//const APIURl = "http://192.168.220.175:8000";
// const APIURl = "http://localhost:8000";
var APIURl = process.env.VUE_APP_BASE_API;
// const APIURl = "http://211.141.162.40:8556";
// const APIURl = "http://172.18.11.117:8060";
// const APIURl = "http://152.136.114.50:8060";
// const APIURl = "http://192.168.1.124:8050";
module.exports = {
  APIURl: process.env.VUE_APP_BASE_API,
  IMG_URL: process.env.NODE_ENV === "development" ? process.env.VUE_APP_BASE_API : process.env.VUE_APP_BASE_API + '/file/',
  timeout: process.env.NODE_ENV === "development" ? 10000000 : 10000000,
  WebSocketUrl: process.env.NODE_ENV === "development" ? APIURl.replace("http", "ws") + "/api/message/websocket" : process.env.VUE_APP_BASE_WSS,
  comUploadUrl: process.env.VUE_APP_BASE_API + "/api/file/Uploader",
  comUrl: process.env.VUE_APP_BASE_API,
  // 本地文件预览
  filePreviewServer: process.env.NODE_ENV === "development" ? "http://localhost:30090" : process.env.VUE_APP_BASE_API + "/FileServer",
  // 大屏应用前端路径
  dataV: process.env.NODE_ENV === "development" ? "http://localhost:8100/DataV" : process.env.VUE_APP_BASE_API + "/DataV",
  // 数据报表接口-java boot
  reportServer: process.env.NODE_ENV === "development" ? "http://localhost:30007" : process.env.VUE_APP_BASE_API + "/ReportServer",
  // 数据报表接口-java cloud
  // reportServer: process.env.NODE_ENV === 'development' ? 'http://localhost:30000' : process.env.VUE_APP_BASE_API,
  // 报表前端
  report: process.env.NODE_ENV === "development" ? "http://localhost:8200" : process.env.VUE_APP_BASE_API + "/Report",
  version: "3.2"
};